import React from "react";
import { Button, PlusIcon } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import IvideonDeleteModal from "~/pages/Editor/IvideonPlans/modals/IvideonDeleteModal";
import IvideonPlanModal from "~/pages/Editor/IvideonPlans/modals/IvideonPlanModal";
import Wrapper from "~/shared/ui/Wrapper";
import { useGetIvideonTariffs } from "~/entity/Ivideon";
import { IvideonTariffsIProps } from "~/entity/Ivideon/model/schema";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import { IVIDEON_PLANS_OPTIONS } from "~/pages/Editor/IvideonPlans/utils/options";
import { usePermissions } from "~/shared/context/PermissionContext";
import { TableV2 } from "~/shared/ui/TableV2";

import { getIvideonPlansColumns } from "./model/tableAdapter";

const IvideonPlans = () => {
  const { t } = useTranslation();
  const { data, isLoading, refetch } = useGetIvideonTariffs();
  const { hasPermission } = usePermissions();
  const setParams = useURLParamsSetter();
  const history = useHistory();

  const goBack = () => history.replace("/editor/");

  const openAddModal = () => {
    setParams({ openModal: "Create" });
  };

  const handleRowEdit = (record: IvideonTariffsIProps) => {
    setParams({ openModal: "Edit", currentId: record.id });
  };

  const handleRowDelete = (record: IvideonTariffsIProps) => {
    setParams({ openModal: "Sure", currentId: record.id });
  };

  return (
    <Wrapper.Content
      title={t("ivideonPlans.editor_title")}
      txtBtn={t("ui.back")}
      goBackHandler={goBack}
      controlComponent={
        <Flex gap={10}>
          {hasPermission("ivideon.createIvideonCameraTariff") && (
            <Button
              onClick={openAddModal}
              size={"middle"}
              icon={<PlusIcon size={16} />}
            >
              {t("ivideonPlans.createPlan")}
            </Button>
          )}
        </Flex>
      }
    >
      <TableV2<IvideonTariffsIProps>
        columns={getIvideonPlansColumns(t, IVIDEON_PLANS_OPTIONS)}
        dataSource={data}
        loading={isLoading}
        rowKey="id"
        onRowEdit={
          hasPermission("ivideon.updateIvideonCameraTariff")
            ? handleRowEdit
            : undefined
        }
        onRowDelete={
          hasPermission("ivideon.deleteIvideonCameraTariff")
            ? handleRowDelete
            : undefined
        }
      />

      <IvideonPlanModal plans={data} reFetch={refetch} />
      <IvideonDeleteModal reFetch={refetch} />
    </Wrapper.Content>
  );
};

export default IvideonPlans;
